module.exports = __webpack_public_path__ + "static/media/chicken4.28a8cbe1.jpg";